<template>
  <component
    v-if="isComponent"
    class="Avt-Img"
    :is="props.src"
    :style="get_styles"
    aria-label="avatar"
  />
  <img
    v-else
    class="Avt-Img"
    :src="props.src"
    :width="props.size"
    :height="props.size"
    :alt="props.alt"
    :style="get_styles"
    aria-label="avatar"
  />
</template>

<script setup>
import { defineProps, computed } from "vue";
import { Props } from "./scripts/props.js";

// Определяем props
const props = defineProps(Props());

// Собираем стили
const get_styles = computed(() => ({
  maxWidth: `${props.size}px`,
  maxHeight: `${props.size}px`,
  minWidth: `${props.size}px`,
  minHeight: `${props.size}px`,
  borderRadius: props.radius,
  filter: props.blur ? "blur(0.5px)" : undefined,
}));

// Определяем, является ли src компонентом или строкой
const isComponent = computed(() => typeof props.src === "object");
</script>

<style lang="scss">
@import "./styles/_style.scss";
</style>
